var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1428,
    cy: 8.85714,
    r: 3.85714
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14286 8.85658C4.14286 9.72446 3.4393 10.428 2.57143 10.428C1.70355 10.428 1 9.72446 1 8.85658C1 7.98871 1.70355 7.28516 2.57143 7.28516C3.4393 7.28516 4.14286 7.98871 4.14286 8.85658ZM5.06184 9.49945C4.77638 10.6085 3.76961 11.428 2.57143 11.428C1.15127 11.428 0 10.2767 0 8.85658C0 7.43642 1.15127 6.28516 2.57143 6.28516C3.8704 6.28516 4.94442 7.24833 5.11826 8.49945L14 8.49945V9.49945L5.06184 9.49945Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeek);
export default __webpack_public_path__ + "static/media/seek.27358fad69f901460ad5abcd94475f4b.svg";
export { ForwardRef as ReactComponent };